import { render, staticRenderFns } from "./OfficeManagement.vue?vue&type=template&id=a728bbc2"
import script from "./OfficeManagement.vue?vue&type=script&lang=js"
export * from "./OfficeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports